<template>
  <v-container>
    <v-container class="ma-0 pa-0 d-flex">
      <h1>Сайты</h1>
    </v-container>
    <v-container class="pa-0 ma-0 mt-1" v-if="loading">
      <v-progress-linear indeterminate></v-progress-linear>
    </v-container>
    <v-container class="pa-0 ma-0 mt-1" v-else-if="isAdmin || isEditor">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0">
          <v-tabs v-model="tab"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          >
            <v-tab href="#tab1">Сайты</v-tab>
            <v-tab>Услуги</v-tab>
            <v-tab>Команда</v-tab>
            <v-tab>Отзывы</v-tab>
            <v-tab>Портфолио</v-tab>
            <v-tab>Статьи</v-tab>
            <v-tab>Вопрос-ответ</v-tab>
            <v-tab>HTML-блоки</v-tab>
            <v-tab>Готовые решения</v-tab>
            <v-tab>Настройки партнеров</v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab1">
          <sites-list></sites-list>
        </v-tab-item>
        <v-tab-item>
          <site-pages></site-pages>
        </v-tab-item>
        <v-tab-item>
          <site-specialists></site-specialists>
        </v-tab-item>
        <v-tab-item>
          <site-testimonials></site-testimonials>    
        </v-tab-item>
        <v-tab-item>
          <site-portfolios></site-portfolios>
        </v-tab-item> 
        <v-tab-item>
          <site-papers></site-papers>    
        </v-tab-item>
        <v-tab-item>
          <site-questions></site-questions>    
        </v-tab-item>
        <v-tab-item>
          <site-html></site-html>    
        </v-tab-item>
        <v-tab-item>
          <site-solutions></site-solutions>    
        </v-tab-item>
        <v-tab-item>
           <site-settings></site-settings>
        </v-tab-item>
      </v-tabs-items>
     
    </v-container>
    <v-container v-else>
      <partner-sites></partner-sites>
    </v-container>
    
  </v-container>
</template>

<script>
import SitesList from '../components/sites/site/SitesList';
import PartnerSites from "../components/sites/site/PartnerSites";
import SiteSpecialists from '../components/sites/site_specialists/SiteSpecialists';
import SiteTestimonials from '../components/sites/site_testimonials/SiteTestimonials';
import SitePapers from '../components/sites/site_papers/SitePapers';
import SiteQuestions from '../components/sites/site_questions/SiteQuestions';
import SitePortfolios from '../components/sites/site_portfolios/SitePortfolios';
import SiteSolutions from '../components/sites/site_solutions/SiteSolutions';
import SitePages from '../components/sites/site_pages/SitePages';
import SiteHtml from '../components/sites/site_html/SiteHtml';
import SiteSettings from '../components/sites/site_settings/SiteSettings';


import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    SitesList,
    PartnerSites,
    SiteSpecialists,
    SiteTestimonials,
    SitePapers,
    SiteQuestions,
    SitePortfolios,
    SiteSolutions,
    SitePages,
    SiteHtml,
    SiteSettings
  },

  data() {
    return {
      tab: 'tab1',
      loading: false
    };
  },

  async created() {
    document.title = "Сайты";
    this.loading = true;
    this.$store.dispatch('sites/loadList').then(() => this.loading = false);
  },
  
  computed: {
    ...mapGetters('users', ['isAdmin', 'isEditor']),
    ...mapGetters('sites', ['loadingList'])
  }
};
</script>